import type { TaskAssignee, TaskResp, TaskStatus } from "@/types/tasks.ts";

/** A move the user can make on a task; each app draws its own icon, keyed by `status`. */
export type TaskAction = { status: TaskStatus; label: string };

const COMPLETE: TaskAction = { status: "done", label: "Mark done" };
const CANCEL: TaskAction = { status: "cancelled", label: "Cancel" };
const REOPEN: TaskAction = { status: "open", label: "Reopen" };

export const TASK_STATUS_LABELS: Record<TaskStatus, string> = {
  open: "Open",
  done: "Done",
  cancelled: "Cancelled",
};

/** Who the work is waiting on. */
export const TASK_ASSIGNEE_LABELS: Record<TaskAssignee, string> = {
  assistant: "Okthx",
  user: "You",
  external: "Someone else",
};

/**
 * Every move the task allows, the promoted one first. The assistant's own work
 * promotes Cancel: the user isn't doing it, so they can't report it finished.
 */
export function taskActions(task: TaskResp): [TaskAction, ...TaskAction[]] {
  if (task.status !== "open") return [REOPEN];
  return task.assignee === "assistant" ? [CANCEL, COMPLETE] : [COMPLETE, CANCEL];
}
